import React from "react";
import { Link } from "react-router-dom";
import Login_Signup from "../../pages/login-signup/login-signup";
import Button1 from "../Buttons/Button1";
import Button2 from "../Buttons/Button2";
import { FiChevronDown } from 'react-icons/fi';
import { IoMdLogOut } from 'react-icons/io';
import { HiOutlinePhotograph } from 'react-icons/hi';
import { BsGear } from 'react-icons/bs';
import { FaBookmark, FaStar, FaWallet } from 'react-icons/fa';
import { useState } from "react";
import { useContext } from "react";
import { logOut } from "../../authContext/apiCalls";
import { AuthContext } from "../../authContext/AuthContext";
import { useNavigate } from "react-router-dom";

const Header = ({handleShow}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const history = useNavigate()
  // const [isSign, setIsSign] = useState(false);
  const {user,dispatch} = useContext(AuthContext);
  const handleLogout = () => {
    
    logOut(dispatch);
    setIsDropdownOpen(false)
    history.push("/")
  }
  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  
  return (
    <div className="bg-white flex flex-row md:flex-row justify-between md:justify-between py-1 px-4 md:px-20 lg:px-20 shadow-gray-400 shadow-md  pb-4 z-50 top-0 sticky ">
      <img
        src="/a2z-logo.png"
        className="h-[50px] w-[50px] rounded-full object-cover"
        alt="A2Z Villaz"
        className="mt-10 md:mt-8 lg:mt-4 h-[5.9vw] "
      ></img>
      {/* <div className="bg-[#c6aa7d] rounded-full w-[130px] flex flex-row items-center scale-[0.75] md:scale-[1]">
       
      </div> */}
      <div className="flex flex-row md:py-1 justify-center mt-[34px]">
        <a
          href="https://host.a2zvillaz.com/login/"
          target="_blank"
          rel="noopener noreferrer"
          className="mx-2 scale-[0.9] md:scale-100 no-underline"
        >
          <Button1 value="Become a Host" />
        </a>
        
        {user ? (<>
        
        <div className="rounded-full bg-white w-10 h-10 flex items-center justify-center mr-2">
          <HiOutlinePhotograph size={24} />
        </div>
        <div className="text-xl font-bold">{user.first_name}</div>
        <button
          className="flex items-center focus:outline-none"
          onClick={handleDropdownToggle}
        >
          <FiChevronDown size={24} />
        </button>
        {isDropdownOpen && (
          <div className="absolute right-0 mt-14 w-48 bg-white rounded-md shadow-lg py-2">
            <Link
              to="/profile"
              className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
            >
              <BsGear className="inline-block mr-2" size={16} />
              Manage Account
            </Link>
            <a
              href="#"
              className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
            >
              <FaBookmark className="inline-block mr-2" size={16} />
              Bookings
            </a>
            <a
              href="#"
              className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
            >
              <FaWallet className="inline-block mr-2" size={16} />
              Rewards and Wallet
            </a>
            <a
              href="#"
              className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
            >
              <FaStar className="inline-block mr-2" size={16} />
              Reviews
            </a>
            <a
              href="#"
              className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
            >
              <FaBookmark className="inline-block mr-2" size={16} />
              Saved
            </a>
            <a
              href="#"
              className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
              onClick={handleLogout}
            >
              <IoMdLogOut className="inline-block mr-2" size={16} />
              Sign Out
            </a>
          </div>
        )}
        
        </>):(<>
        <div  className="mx-2 scale-[0.9] md:scale-100">
          <button onClick={()=>handleShow()}>

          <Button1 value="Login/Signup" />
          </button>
        </div>
        </>)}

        
        
        
      </div>
    </div>
  );
};

export default Header;
